/* CSH free gift (offre Breville) — companion to snippets/csh-free-gift-widget.liquid.
   The widget markup is re-rendered server-side with the cart drawer, so all
   handlers are delegated on document and installed exactly once. */
(function () {
  if (window.__cshFreeGift) return;
  window.__cshFreeGift = true;

  var busy = false;

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-csh-gift-add]');
    if (!button || busy) return;

    var widget = button.closest('[data-csh-free-gift]');
    if (!widget) return;

    var items = [];
    widget.querySelectorAll('[data-csh-gift-slot]').forEach(function (slot) {
      var coffee = slot.querySelector('[data-csh-gift-coffee]');
      if (!coffee || !coffee.value) return;
      var grind = slot.querySelector('[data-csh-gift-grind]');
      var properties = { _free_gift: 'true' };
      if (grind && grind.value) properties['Mouture/Grind'] = grind.value;
      items.push({ id: Number(coffee.value), quantity: 1, properties: properties });
    });

    if (!items.length) return;

    busy = true;
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add.js ' + response.status);
      })
      .then(refreshCart)
      .catch(function (error) {
        console.error('[CSH FREE GIFT]', error);
        button.disabled = false;
      })
      .finally(function () {
        busy = false;
      });
  });

  /* The BxGy discount stops applying the moment the machine leaves the cart,
     so orphaned $0-intent bags would suddenly be charged full price at
     checkout. The widget flags them; we remove them. */
  function cleanOrphans() {
    if (busy) return;
    var marker = document.querySelector('[data-csh-gift-orphans]');
    if (!marker) return;

    var keys = (marker.getAttribute('data-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    busy = true;
    marker.removeAttribute('data-keys');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(refreshCart)
      .catch(function (error) {
        console.error('[CSH FREE GIFT]', error);
      })
      .finally(function () {
        busy = false;
      });
  }

  document.addEventListener('cart:change', cleanOrphans);
  document.addEventListener('DOMContentLoaded', cleanOrphans);
  new MutationObserver(cleanOrphans).observe(document.documentElement, { childList: true, subtree: true });
})();
